<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <div class="ontario-column ontario-small-12">
            <div class="ontario-alert ontario-alert--error">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                            sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </div>
                    <div>
                        <h2 id="pageTitle" class="ontario-alert__header-title ontario-h4">{{ 'bss.app.error.title' | translate }}</h2>
                    </div>
                </div>

                <div class="ontario-alert__body">
                  <p><p>{{ messageKey | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>